const Scope = Object.freeze({
    PAYMENT_ELECTRONIC_WRITE: 'payment.electronic:write',
    PAYMENT_ELECTRONIC_READ: 'payment.electronic:read',
});

export default Scope;
